import { useQuery } from '@tanstack/react-query';
import { authService } from '../api/auth';

/**
 * Optional sign-in providers the API offers this visitor (VK ID today). The
 * API decides by country and interface language; until it answers, the
 * optional buttons stay hidden rather than flash in and out.
 */
export function useAuthProviders() {
  const { data } = useQuery({
    queryKey: ['auth', 'providers'],
    queryFn: () => authService.getProviders(),
    staleTime: 5 * 60 * 1000,
  });
  return { isVkIdAvailable: data?.isVkIdAvailable === true };
}
